export default {
  namespaced: true,

  modules: {},
}
